import React from 'react';
import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { Flex, Padding } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { getColor } from 'common/constants/_colors';
import { SPACES, SIZES } from 'common/constants/sizes';

const Tabs = styled.div`
  display: flex;
  ${({ showUnderline }) =>
    showUnderline ? `border-bottom: 1px solid ${getColor('botticelli')};` : ''};
  padding-right: ${SPACES.small};
  ${({ display }) =>
    display === 'inSpacedSection'
      ? `
    margin-left: -2rem;
    margin-right: -2rem;`
      : `
    padding-top: ${SPACES.small}`};
`;

const Tab = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-left: ${SPACES.medium};
  padding-right: ${SPACES.medium};
  padding-top: ${SPACES.small};
  padding-bottom: ${SPACES.small};
  margin: 2px 2px 0 2px;
  color: ${getColor('shuttleGray')};
  ${({ fontSize }) =>
    `font-size: ${fontSize ? SIZES[fontSize] : SIZES.large};`};
  ${({ selected }) =>
    selected
      ? `
    border-bottom: 2px solid ${getColor('dodgerBlue')};
    color: ${getColor('dodgerBlue')};
  `
      : 'border-bottom: 2px solid transparent'};

  ${({ disabled }) => disabled && `opacity: 0.5; pointer-events: none;`};

  :hover {
    background-color: ${getColor('zircon')};
    color: ${getColor('dodgerBlue')};
  }
`;

export default function TabList({
  display,
  tabs,
  selectedTab,
  onTabClick = () => null,
  fontSize,
  showUnderline = true,
  children,
  selectedAttributeName = 'name',
  enableSelected = true
}) {
  return (
    <Tabs display={display} showUnderline={showUnderline}>
      <Flex grow='1'>
        {tabs.map((tab, idx) => {
          const selected = tab[selectedAttributeName] === selectedTab;
          const { tooltip } = tab;

          return (
            <Tooltip
              key={idx}
              disableHoverListener={!tooltip}
              title={<div className='w-80'>{tooltip}</div>}
            >
              <div>
                <Tab
                  data-testid='tab'
                  key={idx}
                  fontSize={fontSize}
                  selected={selected}
                  onClick={() =>
                    (enableSelected || !selected) && onTabClick(tab)
                  }
                  disabled={tab.disabled}
                >
                  {!!tab.icon && (
                    <Padding r='x-small' data-testid='icon'>
                      <Icon style={{ display: 'block' }} name={tab.icon} />
                    </Padding>
                  )}
                  {tab.name}
                </Tab>
              </div>
            </Tooltip>
          );
        })}
      </Flex>
      {children}
    </Tabs>
  );
}
